import React, { ChangeEvent, TextareaHTMLAttributes } from "react";

export function InputTextArea(props: InputTextAreaParams) {
    const { handleTextChanged, label, hasError, width, rows, required, ...rest } = props;

    const errorClassName = hasError? "error" : "";

    const renderLabel = (label: string | undefined) => {
        if (!label) return null;
        return (
            <div className={"textarea__label"}>
                {label}
                {required ? <p className="input_required_label">必須</p> : null}
            </div>
        );
    };

    const style = { width: width ?? "100%" };

    return (
        <div className={`input textarea ${errorClassName}`} >
            {renderLabel(label)}
            <textarea 
                className={`${errorClassName}`} 
                rows={rows ? rows : 5} 
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => { handleTextChanged(e.target.value); }} 
                style={style} 
                {...rest}
            />
        </div>
    );
}

export interface InputTextAreaParams extends TextareaHTMLAttributes<HTMLTextAreaElement>  {
    handleTextChanged: (value: string) => void,
    label?: string,
    hasError?: boolean,
    width?: number,
    rows?: number
}
